import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StandardButton } from "../../../_components/button/primary.button";
import { PRIMARY_COLOR } from "../../../_const/color.const";

export const BookingCancelled = () => {
    let navigate = useNavigate();

    return (
        <Box display="flex" flexDirection="column" justifyContent="center">
            <Box display="flex" flexDirection="column" gap={5} marginBottom={{ xs: "30px", md: "100px" }}>
                <Box>
                    <Typography align="center" fontFamily="Poppins" variant="h5" sx={{ color: PRIMARY_COLOR[0] }}>
                        Your booking is now cancelled!
                        <br />
                        An email will arrive in your inbox confirming your appointment cancellation.
                        <br />
                        If payment was made a member of our team will be in touch to arrange a refund.
                        <br />
                        <span style={{ fontSize: "30px", fontWeight: "600" }}>Thank you!</span>
                    </Typography>
                </Box>
                <Box sx={{ flexGrow: 1, padding: 2 }}>
                    <StandardButton
                        variant="primary"
                        type="button"
                        onClick={(e) => navigate('/')}
                    >
                        <Typography align="center"
                            fontSize={{ xs: "14px", sm: "16px", md: "16px" }}
                            fontWeight="600"
                            letterSpacing="1.5px"
                            textTransform="none">
                            Make Another Booking
                        </Typography>
                    </StandardButton>
                </Box>
            </Box>
        </Box>
    );
}